export default __webpack_public_path__ + "static/media/gwn16.a3842aaa.webp";